import { useShowResponseStatus } from '@/shared';
import { useCreateRemotePaymentMethodMutation } from '../store/remote-payment-methos-api';

import type { TRemotePaymentMethodCreateParams } from '../store/types';

export const useCreateRemoteMethod = () => {
  const [createRemoteMethod, { isLoading, isSuccess, isError }] = useCreateRemotePaymentMethodMutation();

  useShowResponseStatus({
    isSuccess,
    isError,
  });

  const handleRemoteMethodCreate = async (params: TRemotePaymentMethodCreateParams) => {
    await createRemoteMethod(params);
  };

  return {
    handleRemoteMethodCreate,
    createRemoteMethod,
    isLoading,
  };
};
